(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["verik-collection-panel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope) => {
      scope.querySelectorAll('[data-vv2-discovery]').forEach((root) => {
        if (root.dataset.discoveryBound === 'true') return;
        const trigger = root.querySelector('[data-vv2-discovery-open]');
        const dialog = root.querySelector('[data-vv2-discovery-dialog]');
        if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
        root.dataset.discoveryBound = 'true';
        trigger.addEventListener('click', (event) => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (!dialog.open) dialog.showModal();
          trigger.setAttribute('aria-expanded', 'true');
        });
        dialog.addEventListener('close', () => {
          trigger.setAttribute('aria-expanded', 'false');
          if (trigger.isConnected) trigger.focus({ preventScroll: true });
        });
        root.querySelectorAll('[data-vv2-discovery-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
        dialog.addEventListener('click', (event) => {
          if (event.target.closest('a[href]')) { dialog.close(); return; }
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        });
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-vv2-discovery-dialog]').forEach((dialog) => { if (dialog.open) dialog.close(); });
    });
    const openForEditor = (event) => {
      const root = event.target.closest('[data-vv2-discovery]') || event.target.querySelector('[data-vv2-discovery]');
      root?.querySelector('[data-vv2-discovery-open]')?.click();
    };
    document.addEventListener('shopify:section:select', openForEditor);
    document.addEventListener('shopify:block:select', openForEditor);
  })();

  } catch(e) { console.error(e); }
})();
})();
